
import React from 'react'; 

export function InputCheckFilter (props) {
  return (
    <label className='form__label_course font20Norm colorGrey'>
      <input
        type="checkbox"
        className='form__input_course'
        name={props.name}
        value= {props.value}
        checked={props.checked}
        onChange={props.onChange}
        id={props.id}
      />
      <span className="visible-check item__link"></span>
     {props.item.nameRu} 
    </label>  
  )
}
